import { render, staticRenderFns } from "./datosBasicos.vue?vue&type=template&id=0e2d1554&scoped=true"
import script from "./datosBasicos.vue?vue&type=script&lang=js"
export * from "./datosBasicos.vue?vue&type=script&lang=js"
import style0 from "./datosBasicos.vue?vue&type=style&index=0&id=0e2d1554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2d1554",
  null
  
)

export default component.exports